import React from "react";
// import ChartV5 from '../../pages/aprobacion-presidencial/ChartV5';
import ChartApi from "../../pages/confianza-presidente/ChartApi";

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi />
            {/* <ChartV5 /> */}
          </div>
        </div>
      </div>
    </div>
  )
}
